export function DeviceOrientaionIcon({ active }: any) {
  const color: string = active ? "#006AB3" : "#000000";
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3496 14.6047C17.3496 14.8215 17.2922 15.0223 17.1775 15.2072C17.0627 15.3921 16.9065 15.5356 16.7088 15.6376L9.01913 19.4633C8.93624 19.5016 8.85335 19.5303 8.77046 19.5494C8.68757 19.5685 8.60149 19.5813 8.51222 19.5877C8.28905 19.5877 8.0882 19.5335 7.90967 19.4251C7.73114 19.3167 7.58767 19.1573 7.47928 18.9469L0.774708 5.4899C0.691817 5.31137 0.650372 5.1424 0.650372 4.983C0.650372 4.76621 0.707758 4.56536 0.822529 4.38045C0.937301 4.19554 1.09352 4.05207 1.29118 3.95005L8.98087 0.124336C9.1594 0.0414453 9.32837 0 9.48778 0C9.71095 0 9.91498 0.0573858 10.0999 0.172157C10.2848 0.286929 10.4251 0.443146 10.5207 0.640808L17.2253 14.0978C17.3082 14.2763 17.3496 14.4453 17.3496 14.6047ZM8.54091 18.3347L16.0967 14.576L9.45909 1.25292L1.90329 5.01169L8.54091 18.3347ZM12.6249 14.6716L10.7024 15.6281L10.1573 14.5282L12.0797 13.5717L12.6249 14.6716ZM15.1211 3.31881L14.3273 4.10308L13.4665 3.24229L15.7333 0.975558L18 3.24229L17.1392 4.10308L16.3454 3.31881V6.12115H15.1211V3.31881ZM2.87885 16.2689L3.67269 15.4846L4.53347 16.3454L2.26674 18.6121L0 16.3454L0.860786 15.4846L1.65462 16.2689V13.4665H2.87885V16.2689Z"
        fill={color}
      />
    </svg>
  );
}
